import { CreateEditView as Action, CreateEditViewType as ActionType } from '../../types';

export const DELAY_PER_CHART_IN_MS = 150;
export const TWO_WEEKS_IN_DAYS = 14;
export const TWO_WEEKS_DIFFERENCE_FROM_TODAY = TWO_WEEKS_IN_DAYS - 1;

const DEFAULT_SCENE = 'forecasting-studio';
const CREATE_FORECAST = `${DEFAULT_SCENE}:create-new-forecast`;
const EDIT_FORECAST = `${DEFAULT_SCENE}:edit-forecast`;
const VIEW_FORECAST = `${DEFAULT_SCENE}:view-forecast`;
const CREATE_FORECAST_SCREEN_2 = `${CREATE_FORECAST}(2)`;

export const CANCEL_BUTTON = `cancel-button`;
export const NEXT_STEP_BUTTON = `next-step-button`;
export const SAVE_BUTTON = `save-button`;
export const PREVIOUS_STEP_BUTTON = `previous-step-button`;
export const ADJUSTMENTS_SIDEBAR_TOGGLE_BUTTON = 'adjustments-sidebar-toggle-button';
export const PUT_TO_PRODUCTION_TOGGLE_BUTTON = 'put-to-production-toggle-button';
export const PROCEED_TO_SCHEDULE_BUTTON = 'proceed-to-schedule-button';

export const getButtonTestId = (action: ActionType, page: number, button: string) => {
  let name = VIEW_FORECAST;

  if (action === Action.CREATE) {
    name = CREATE_FORECAST;
  }

  if (action === Action.EDIT) {
    name = EDIT_FORECAST;
  }

  return `${name}(${page}):${button}`;
};

// ForecastStudioScene
export const STUDIO_TITLE_TAG = `${DEFAULT_SCENE}:title`;
export const LIST_OF_FORECASTS_CONTAINER_TAG = `${DEFAULT_SCENE}:list-of-forecasts`;
export const getForecastPropTag = (propName: string) => `${LIST_OF_FORECASTS_CONTAINER_TAG}:forecast-${propName}`;
export const FILTER_QUEUE_INPUT = `${DEFAULT_SCENE}:filter-forecasts:input-name`;

// CreateForecast Screen #1
export const CREATE_FORECAST_TITLE = `${CREATE_FORECAST}:title`;
export const EDIT_FORECAST_TITLE = `${EDIT_FORECAST}:title`;
export const VIEW_FORECAST_TITLE = `${VIEW_FORECAST}:title`;
export const NAME_INPUT = `${CREATE_FORECAST}:name-input`;
export const QUEUE_DROPDOWN = `${CREATE_FORECAST}:queue-dropdown`;
export const CONCURRENT_CHATS_INPUT = `${CREATE_FORECAST}:concurrent-chats-input`;
export const HISTORICAL_DATA_START_DATE_INPUT = `${CREATE_FORECAST}:historical-data-start-date-input`;
export const HISTORICAL_DATA_END_DATE_INPUT = `${CREATE_FORECAST}:historical-data-end-date-input`;
export const FORECAST_START_DATE_INPUT = `${CREATE_FORECAST}:forecast-start-date-input`;
export const FORECAST_END_DATE_INPUT = `${CREATE_FORECAST}:forecast-end-date-input`;

// CreateForecast Screen #2
const SHRINKAGE = `${CREATE_FORECAST_SCREEN_2}:shrinkage`;
const DATE_RANGE = `${CREATE_FORECAST_SCREEN_2}:date-range`;
export const SHRINKAGE_LABEL = `${SHRINKAGE}-label`;
export const SHRINKAGE_INPUT = `${SHRINKAGE}-range-input`;
export const SHRINKAGE_VALUE_INDICATOR = `${SHRINKAGE}-value-indicator`;
export const DATE_RANGE_LABEL = `${DATE_RANGE}-label`;
export const DATE_RANGE_END_DATE = `${DATE_RANGE}-end-date`;
export const DATE_RANGE_START_DATE = `${DATE_RANGE}-start-date`;

export const CHART = `${CREATE_FORECAST_SCREEN_2}:chart`;
export const CONTACT_VOLUME_CHART = `${CHART}-contact-volume`;
export const CONTACT_VOLUME_TITLE = `${CONTACT_VOLUME_CHART}:title`;
export const AVERAGE_HANDLING_TIME_CHART = `${CHART}-average-handling-time`;
export const AVERAGE_HANDLING_TIME_TITLE = `${AVERAGE_HANDLING_TIME_CHART}:title`;
export const WORKLOAD_REQUIREMENTS_CHART = `${CHART}-workload-requirements`;
export const WORKLOAD_REQUIREMENTS_TITLE = `${WORKLOAD_REQUIREMENTS_CHART}:title`;
export const STAFFING_REQUIREMENTS_CHART = `${CHART}-staffing-requirements`;
export const STAFFING_REQUIREMENTS_TITLE = `${STAFFING_REQUIREMENTS_CHART}:title`;

export const SKIP_SWITCH_TO_EDIT = 'skipSwitchToEdit';

// SideBar Filter
const FILTER_SIDEBAR = `${DEFAULT_SCENE}:filter-sidebar`;
export const TOGGLE_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-toggle`;
export const APPLY_FILTER_BUTTON_TAG = `${FILTER_SIDEBAR}:button-apply`;
export const FILTER_SIDEBAR_DROPDOWN_TOGGLE = `${FILTER_SIDEBAR}:dropdown-toggle`;
export const RESET_ALL_SIDEBAR_FILTERS_BUTTON_TAG = `${FILTER_SIDEBAR}:reset-all-filters`;
export const ACTIVE_SIDEBAR_FILTERS_COUNTER = `${FILTER_SIDEBAR}:active-filters-counter`;
